import { reactive, readonly, nextTick } from "vue";
import AOS from "aos";
import { getParametres } from "@/services/api";

/**
 * Paramètres du site (coordonnées, réseaux sociaux…) gérés depuis l'admin.
 * Les valeurs par défaut ci-dessous s'affichent tant que l'API n'a pas répondu
 * (ou si elle est indisponible), le site reste donc toujours complet.
 */
const state = reactive({
  charge: false,
  nomSite: "Groupe VIRAS",
  slogan: "African Excellence & Innovation",
  description:
    "Le Groupe VIRAS est un groupe multidisciplinaire basé au Mali, intervenant dans le tourisme, la santé, le consulting, la formation professionnelle, la gastronomie, la mode de luxe et les technologies numériques, à travers plusieurs filiales spécialisées.",
  telephone: "+223 90 20 20 17",
  whatsapp: "22390202017",
  email: "contact@groupeviras.com",
  adresse: "Sabalibougou Courani, Bamako, Mali",
  horaires: "Lun - Sam : 08h00 - 18h00",
  reseaux: {},
  latitude: 12.645655,
  longitude: -7.8893237,
  formulaireContactActif: true,
});

let promesse = null;

export function chargerParametres(force = false) {
  if (promesse && !force) return promesse;
  promesse = getParametres()
    .then((p) => {
      Object.entries(p || {}).forEach(([k, v]) => {
        if (v !== null && v !== "" && k in state) state[k] = v;
      });
      if (p && p.reseaux && !Array.isArray(p.reseaux)) state.reseaux = p.reseaux;
      state.charge = true;
    })
    .catch(() => {
      promesse = null; // on réessaiera à la prochaine page
    });
  return promesse;
}

/** Applique des paramètres déjà reçus (ex : via /accueil). */
export function appliquerParametres(p) {
  if (!p) return;
  Object.entries(p).forEach(([k, v]) => {
    if (v !== null && v !== "" && k in state && k !== "reseaux") state[k] = v;
  });
  if (p.reseaux && !Array.isArray(p.reseaux)) state.reseaux = p.reseaux;
  state.charge = true;
}

export function useSite() {
  chargerParametres();
  return readonly(state);
}

export const telLink = (tel) => "tel:" + String(tel || "").replace(/[^\d+]/g, "");

export function formatDate(iso, options = { day: "numeric", month: "long", year: "numeric" }) {
  if (!iso) return "";
  try {
    return new Intl.DateTimeFormat("fr-FR", options).format(new Date(iso));
  } catch (e) {
    return "";
  }
}

export const CATEGORIES = {
  actualite: { label: "Actualité", icon: "bi-newspaper", color: "#2563eb" },
  recrutement: { label: "Recrutement", icon: "bi-megaphone-fill", color: "#16a34a" },
  evenement: { label: "Événement", icon: "bi-calendar-event", color: "#d97706" },
  promotion: { label: "Promotion / Offre", icon: "bi-tag-fill", color: "#dc2626" },
  communique: { label: "Communiqué", icon: "bi-file-earmark-text", color: "#475569" },
};

/** Les animations au défilement (AOS) doivent être recalculées après l'arrivée des données. */
export function rafraichirAnimations() {
  nextTick(() => {
    try {
      AOS.refreshHard();
    } catch (e) {
      /* animations indisponibles : sans conséquence */
    }
  });
}
